module.exports = __webpack_public_path__ + "img/symbol_4.e52f1b3d.png";